(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-look-carousel]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-look-track]');
      const prev = section.querySelector('[data-look-prev]');
      const next = section.querySelector('[data-look-next]');
      const update = () => {
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-help-search]').forEach(input => {
      if (input.dataset.ready) return;
      input.dataset.ready = 'true';
      const page = input.closest('[data-service-page]');
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase(); let visible = 0;
        page.querySelectorAll('.mv-faq-group').forEach(group => {
          let matches = 0;
          group.querySelectorAll('details').forEach(item => {
            const show = !query || item.textContent.toLowerCase().includes(query);
            item.hidden = !show; if (show) matches++;
          });
          group.hidden = !matches; visible += matches;
        });
        page.querySelector('[data-help-empty]').hidden = visible > 0;
      });
    });
    const topic = new URLSearchParams(location.search).get('topic');
    const select = root.querySelector('#MVTopic');
    if (select && [...select.options].some(option => option.value === topic)) select.value = topic;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
